import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withStyles } from "tss-react/mui";
import withMediaQuery from 'components/WithMediaQuery';

import Dialog from '@mui/material/Dialog';
import DialogActions from 'components/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTransition from 'components/DialogTransition';
import ResponsiveDialogHeader from 'components/ResponsiveDialogHeader';

import styles from './styles';
import m from 'messages';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import EventButton from 'components/EventButton';
import SecondaryDialogButton from 'components/SecondaryDialogButton';
import sentinelNumberFormatter from 'utilities/formatters/sentinelNumberFormatter';

class MultiplePersonMatchDialog extends React.Component {

    handleClose() {
        this.props.handleClose();
    }

    render() {
        let { classes, baseTitle, matches, fullScreen } = this.props;

        const isOpen = Boolean(this.props.open);

        return (
            <div>
                <Dialog
                    fullScreen={fullScreen}
                    open={isOpen}
                    TransitionComponent={DialogTransition}
                    className={classes.root}>
                    <ResponsiveDialogHeader
                        fullScreen={fullScreen}
                        title="Multiple Results Found"
                        fullScreenTitle={baseTitle}
                        handleClose={this.props.handleClose}
                        showBackIcon={false} />
                    <DialogContent className={classes.contentRoot}>
                        <List className={classes.list}>
                            {matches && matches.map((m, index) =>
                                <ListItem key={`key-${index}`} className={classes.listItem}>
                                    <ListItemAvatar>
                                        <Avatar className={classes.avatar}>
                                            <img src={"data:image/png;base64," + m.photo} alt="avatar" style={{ width: '100%' }} />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary={m.name} secondary={sentinelNumberFormatter(m.sentinelNumber)} />
                                    <ListItemSecondaryAction>
                                        <EventButton aria-label="select" onClick={() => this.props.select(m)}>
                                            Select
                                        </EventButton>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            )}
                        </List>
                    </DialogContent>
                    <DialogActions fullScreen={fullScreen}>
                        {!fullScreen &&
                            <SecondaryDialogButton onClick={this.props.handleClose}>
                                {m.general.cancel}
                            </SecondaryDialogButton>
                        }
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

MultiplePersonMatchDialog.propTypes = {
    matches: PropTypes.array,
    open: PropTypes.bool,
    select: PropTypes.func,
    handleClose: PropTypes.func
};

const Media = withMediaQuery(theme => theme.breakpoints.down('lg'))(MultiplePersonMatchDialog);
export default compose(withStyles(Media,styles));